var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakeAnOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -2 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-511.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_make_an_offer",
    transform: "translate(509.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4725952,11.982605 L10.0212402,17.4336548 C9.96630859,17.4888916 9.92755125,17.5575562 9.90985109,17.6338501 L9.00134281,21.4888305 C8.96868898,21.6286011 9.00988766,21.7763062 9.11242672,21.8788452 C9.19238281,21.9575805 9.29888914,22 9.40753172,22 C9.43865969,22 9.47131344,21.9963379 9.50244141,21.9887085 L13.3574219,21.079895 C13.4324952,21.0625 13.5011597,21.0237427 13.5563965,20.968811 L19.0074463,15.5174561 L15.4725952,11.982605 Z",
    id: "Path",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5111084,10.6575317 L20.3325195,9.47863766 C19.7026367,8.84875484 18.6049195,8.84875484 17.9750366,9.47863766 L16.3548584,11.0988159 L19.8912353,14.6348877 L21.5111084,13.0150147 C21.826355,12.7000733 22,12.281372 22,11.8361206 C22,11.3899536 21.826355,10.9724731 21.5111084,10.6575317 L21.5111084,10.6575317 Z",
    id: "Path",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,5.33374023 C16.5401001,5.33374023 16.1662598,5.70758055 16.1662598,6.16748047 L16.1662598,7.83374023 C16.1662598,8.29364016 16.5401001,8.66748047 17,8.66748047 C17.4598999,8.66748047 17.8337402,8.29364016 17.8337402,7.83374023 L17.8337402,6.16748047 C17.8337402,5.70635984 17.4598999,5.33374023 17,5.33374023 Z",
    id: "Path",
    fill: "#A3C7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1411133,9.5 L10.75,9.5 L10.75,7 C10.75,6.54010008 10.3761597,6.16625977 9.91625977,6.16625977 C9.45635984,6.16625977 9.08374023,6.54010008 9.08374023,7 L9.08374023,9.5 L3.66625977,9.5 L3.66625977,5.95874023 C3.66625977,5.49884031 3.29241945,5.125 2.83251953,5.125 C2.37261961,5.125 2,5.49761961 2,5.95874023 L2,17.4174805 C2,18.5649414 2.93505859,19.5 4.08374023,19.5 L7.70007328,19.5 C8.15997313,19.5 8.53381344,19.1261597 8.53381344,18.6662598 C8.53381344,18.2063598 8.15997313,17.8325195 7.70007328,17.8325195 L4.08374023,17.8325195 C3.85363766,17.8325195 3.66748047,17.6463623 3.66748047,17.4162598 L3.66748047,15.3325195 L9.91748047,15.3325195 C10.3773804,15.3337402 10.75,14.9598999 10.75,14.5 L10.75,11.1662598 L14.1411133,11.1662598 C14.6013184,11.1662598 14.9748535,10.7924195 14.9748535,10.3325195 C14.9748535,9.87261961 14.6025391,9.5 14.1411133,9.5 Z M3.66625977,11.1662598 L9.08251953,11.1662598 L9.08251953,13.6662598 L3.66625977,13.6662598 L3.66625977,11.1662598 Z",
    id: "Shape",
    fill: "#A3C7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9587402,2 L3.875,2 C2.84014891,2 2,2.84014891 2,3.875 L2,7 L17.8337402,7 L17.8337402,3.875 C17.8337402,2.84014891 16.9938965,2 15.9587402,2 Z",
    id: "Path",
    fill: "#1A73E8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeAnOffer);
export default __webpack_public_path__ + "static/media/make-an-offer.19c93cfd6b5e7a93b71e7fb799cbeebf.svg";
export { ForwardRef as ReactComponent };